module.exports = __webpack_public_path__ + "img/upload.ada26a7a.svg";